import { render, staticRenderFns } from "./chooseSubjectFirst.vue?vue&type=template&id=325f9b80&scoped=true&"
import script from "./chooseSubjectFirst.vue?vue&type=script&lang=js&"
export * from "./chooseSubjectFirst.vue?vue&type=script&lang=js&"
import style0 from "./chooseSubjectFirst.vue?vue&type=style&index=0&id=325f9b80&scoped=true&lang=less&"
import style1 from "./chooseSubjectFirst.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325f9b80",
  null
  
)

export default component.exports